import axios from "axios";
import api from "lib/api/api";
import {
  FETCH_APPROVED_COURSES_FAILURE,
  FETCH_APPROVED_COURSES_REQUEST,
  FETCH_APPROVED_COURSES_SUCCESS,
  MARK_COURSE_PENDING_SUCCESS,
} from "./types";

// Fetch approved courses
export const fetchApprovedCourses = () => async (dispatch) => {
  dispatch({ type: FETCH_APPROVED_COURSES_REQUEST });
  try {
    const response = await api.get(`/courses/approved/grouped`);
    dispatch({ type: FETCH_APPROVED_COURSES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_APPROVED_COURSES_FAILURE, payload: error.message });
  }
};

// Mark course as pending
export const markCoursePending = (teacherCourseId) => async (dispatch) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/admin/pending/${teacherCourseId}`
    );
    dispatch({ type: MARK_COURSE_PENDING_SUCCESS, payload: teacherCourseId });
  } catch (error) {
    console.error("Failed to mark course as pending", error);
  }
};
